<template>
  <div class="searchselect-input">
    <div class="searchselect w-100 mb-3 position-relative">
      <div
        class="select-label mb-2 color_grey_dark font-weight-bold text-capitalize"
      >
        ASSIGN TO TOPIC <span class="brand_tonic">*</span>
      </div>

      <!-- INPUT BLOCK -->
      <div
        class="input-block w-100 position-relative rounded-5 index-1 d-flex justify-content-start align-items-center flex-wrap"
        v-on-clickaway="forceCloseDropdown"
        @click="dropOption"
      >
        <!-- DROPDOWN -->
        <div class="avatar dropdown border pointer">
          <span
            class="icon-caret-down color_grey_dark font-8 flex-center"
          ></span>
        </div>

        <div
          class="placeholder border_grey_dark font-14"
          v-if="Object.keys(this.selected).length === 0"
        >
          {{ placeholder }}
        </div>
        <!-- SELECTED ITEM -->
        <div
          class="selected-item font-12-5 pointer d-flex justify-content-around align-items-center nowrap"
        >
          {{ selected.name }}
        </div>
      </div>
    </div>

    <!-- OPTIONS BLOCK -->
    <div
      class="options-block d-flex justify-content-start align-items-start flex-wrap rounded-5"
      v-if="show_options"
    >
      <div
        class="search-bar-section position-relative rounded-40 overflow-hidden ignore"
      >
        <!-- SEARCH ICON -->
        <div class="avatar avatar_xs">
          <span class="icon-search font-14 brand_inverse"></span>
        </div>

        <input
          type="text"
          class="select-input rounded-20 ignore"
          v-model.trim="query"
        />
      </div>

      <div
        class="loader w-100 my-3 d-flex justify-content-center align-items-center border_grey_dark"
        v-if="isFetching"
      >
        <div class="icon-dotted-roller font-18 mr-2 animate row"></div>
        <div class="font-13">Loading ...</div>
      </div>

      <template v-else>
        <div
          class="w-100 text-center border_grey_dark font-13 py-3"
          v-if="topic_list.length === 0"
        >
          No item found
        </div>

        <!-- ITEMS -->
        <template v-else>
          <div
            class="item w-100 rounded-5 color_grey_dark font-13 pointer d-flex justify-content-between align-items-center"
            v-for="(option, index) in topic_list"
            :key="index"
            @click="selectTopic(index)"
          >
            <div>
              {{ option.name }}
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SearchSelect",

  mixins: [clickaway],

  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    editable: Object,
  },

  watch: {
    query: {
      handler(val) {
        if (val.length) this.fetchTopics();
      },
    },

    clear: {
      handler(val) {
        if (val) this.selected = {};
      },
    },

    editable: {
      handler(val) {
        if (typeof val === "object") {
          if (Object.keys(val).length) {
            this.selected = val;
          }
        }
      },
    },
  },

  mounted() {
    this.getTopics();
  },

  data() {
    return {
      query: "",
      show_options: false,
      selected: {},
      topic_list: [],
      placeholder: "Select Topic",
      isFetching: false,
      search_results: [],
    };
  },

  computed: {
    ...mapGetters(["getCurrentlySelectHomework", "getAuthUser"]),
  },

  methods: {
    ...mapActions(["getTopicList", "searchForTopic"]),

    getTopics() {
      this.getTopicList({
        global_class_id: this.getCurrentlySelectHomework.global_class_id,
        subject_id: this.getCurrentlySelectHomework.subject_id,
      })
        .then((response) => {
          // console.log(response.data);

          let filtered_data = [];
          response.data.map((item) => {
            if (item.term === this.getAuthUser.term.toLowerCase())
              filtered_data.push(item);
          });

          console.log("Filtered", filtered_data);

          if (filtered_data.length > 0) {
            filtered_data.map((topic) => {
              let topic_data = {};
              topic_data.id = Number(topic.id);
              topic_data.name = topic.topic;
              topic_data.selected = false;
              this.topic_list.push(topic_data);
            });
          } else this.topic_list.push({});

          // if (this.topic_list.length > 6) this.topic_list.length = 6;
        })
        .catch((err) => console.log(err));
    },

    fetchTopics() {
      this.isFetching = true;
      this.searchForTopic({
        global_class_id: this.getCurrentlySelectHomework.global_class_id,
        subject_id: this.getCurrentlySelectHomework.subject_id,
        topic: this.query,
      })
        .then((res) => {
          if (res.code === 200) {
            this.isFetching = false;
            this.search_results = [];
            res.data.map((topic) => {
              let topic_data = {};
              topic_data.id = Number(topic.id);
              topic_data.name = topic.topic;
              topic_data.selected = false;
              this.search_results.push(topic_data);
            });
            this.topic_list = this.search_results;
          } else {
            this.search_results = [];
            this.isFetching = false;
            this.topic_list = [];
          }
        })
        .catch((err) => {
          this.isFetching = false;
          this.search_results = [];
          this.topic_list = [];
          console.log(err);
        });
    },

    selectTopic(index) {
      let topic = this.topic_list[index];
      this.show_options = false;
      this.selected = topic;

      this.$emit("topicSelected", { selection: this.selected, clear: false });
      this.query = "";
    },

    setPlaceholder() {
      if (this.selected.length < 1) return this.placeholder;
      else return;
    },

    dropOption() {
      this.show_options = !this.show_options;
    },

    forceCloseDropdown($event) {
      if (!$event.target.classList.contains("ignore"))
        this.show_options = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.searchselect-input {
  width: 100%;
  max-width: 380px;
  .select-label {
    font-size: 13.5px;

    @include breakpoint_max(sm) {
      font-size: 11.5px !important;
    }

    @include breakpoint_max(xs) {
      font-size: 11px !important;
    }
  }
  .input-block {
    padding: 0.7rem 0.75rem;
    font-size: 13.5px;
    top: 0;
    left: 0;
    margin: 0;
    min-height: 3rem;
    max-height: 3.5rem;
    height: auto;
    border: 0.0625rem solid $border_grey;
    text-indent: 0.0006rem;

    @include breakpoint_max(sm) {
      padding: 0.4375rem 0.625rem;
      font-size: 0.75rem;
    }

    @include breakpoint_max(xs) {
      padding: 7px 8px 9px;
      font-size: 11.75px;
      line-height: 15px;
    }

    .dropdown {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);

      @include breakpoint_max(xs) {
        @include equal_min_edge(28);
      }

      span {
        @include breakpoint_max(sm) {
          font-size: 10px !important;
        }

        @include breakpoint_max(xs) {
          font-size: 9px !important;
          position: relative;
          top: 1px;
        }
      }
    }
    .placeholder {
      @include breakpoint_max(sm) {
        font-size: 12px !important;
      }
    }

    .selected-item {
      transition: all 0.4s ease-in-out;
      .avatar {
        @include equal_min_edge(25);
        margin-left: 10px;
      }

      @include breakpoint_max(sm) {
        padding: 7px 6px;
        margin-left: 0px;
        font-size: 11.5px !important;
      }

      @include breakpoint_max(xs) {
        font-size: 11px !important;
        padding-right: 35px;
      }
    }
  }

  .options-block {
    margin-top: -10px;
    padding: 6px 2px 5px;
    border: 0.0625rem solid $border_grey;
    max-height: 200px;
    overflow-y: auto;

    .search-bar-section {
      @include flex_row_between_nowrap;
      width: 400px;
      height: 40px;
      border: 0.0625rem solid $border_grey;
      margin: 7px 13px;

      @include breakpoint_max(md) {
        width: 530px;
        margin-top: 10px;
      }

      @include breakpoint_max(sm) {
        width: 100%;
      }

      .avatar {
        margin: 0 10px;
      }

      input {
        flex: 1;
        font-size: 14px;
        background: transparent;
        border: 0;
        outline: 0;

        @include breakpoint_max(sm) {
          font-size: 13px;
        }

        &:hover {
          border: 0;
        }

        &::placeholder {
          font-size: 14px;
          color: $border_grey_dark;
          @include breakpoint_max(sm) {
            font-size: 12.5px;
          }
        }
      }
    }

    .item {
      padding: 10px 13px;
      margin: 0px 7px;
      font-size: 13px !important;

      @include breakpoint_max(sm) {
        font-size: 11.5px !important;
      }

      .avatar {
        @include equal_min_edge(18);
        span {
          position: relative;
          top: 0.5px !important;
        }
      }
      &:hover {
        background: rgba($brand_green_light, 0.5) !important;
      }
    }
  }
  .active {
    border: 0.0625rem solid $brand_accent;
  }
}
</style>
